export default __webpack_public_path__ + "static/media/partners-logo-sogang-w@3x.1bf0b4f3.webp";